import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLightUp = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m4.254 27.464 1.43 1.431a.867.867 0 0 0 1.227 0L20 15.837l13.089 13.058a.867.867 0 0 0 1.226 0l1.431-1.43a.867.867 0 0 0 0-1.227L20.613 11.105a.867.867 0 0 0-1.226 0L4.254 26.238a.867.867 0 0 0 0 1.226Z" })
});
export default SvgChevronLightUp;
